//resources/js/store/actions/geoJsonActions.js

// Action Types
export const REMOVE_FEATURE = 'REMOVE_FEATURE';
export const RESET_VECTOR_REMOVE_FEATURE = 'RESET_VECTOR_REMOVE_FEATURE';
export const REPLACE_PARCELLES = 'REPLACE_PARCELLES';

// Action Creators
export const removeFeatureAction = (featureId) => ({
  type: REMOVE_FEATURE,
  data: { featureId },
});

export const resetVectorRemoveFeatureAction = () => ({
  type: RESET_VECTOR_REMOVE_FEATURE,
});

export const replaceParcelles = (newParcelles) => ({
  type: REPLACE_PARCELLES,
  payload: newParcelles,
});